

const ChatReducer=(state,action)=>{

    switch(action.type){

        case "LOGIN_DATA":
        return{
            ...state,
            login:action.payload

        }

        // case "ADD_USER":

        // return{
        //     ...state,
        //     UserData:action.payload
        // }

        case "ADD_PERSON_DATA":

        return{
            ...state,
            PersonData:action.payload
        }




        // case "ADD_USER_INFILTER":

        // return{
        //     ...state,
        //     FilterData:action.payload
        // }

        case "CONVERSATION_DATA":


        return{
            ...state,
            Convesation:action.payload
        }




        case "FILTER_PERSON_DATA":

        return{
            ...state,
            Search:action.payload
        }


        case "SORTING_USER_SEARCH":

        let searching;
        let temappp = [...action.payload]
           searching=temappp.filter((ele)=>ele.name.toLowerCase().includes(state.Search))
       
        return{
       
         ...state,
         FilterData: searching
       
        }


        case "MESSAGE_DATA":

        return{
            ...state,
            Message:action.payload
        }



        default:
        return state
    }

}

export default ChatReducer